var Scope;
(function (Scope) {
    Scope["CLIENT_SUPERUSER"] = "CLIENT_SUPERUSER";
    Scope["CLIENT_ADMIN"] = "CLIENT_ADMIN";
    Scope["VERIFIED_CONSUMER"] = "VERIFIED_CONSUMER";
    Scope["UPDATE_PROFILE"] = "UPDATE_PROFILE";
    Scope["ONE_TIME"] = "ONE_TIME";
    Scope["PASSWORD_RESET"] = "PASSWORD_RESET";
    Scope["BACKEND"] = "BACKEND";
    Scope["CLIENT_REPORT_DOWNLOAD"] = "CLIENT_REPORT_DOWNLOAD";
})(Scope || (Scope = {}));
export default Scope;
